define( [
	"./arr"
], function( arr ) {
	"use strict";

	return arr.slice;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/slice.js
// module id = 23
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24